module.exports = __webpack_public_path__ + "img/spin_btn.a61183e9.png";